import RichTextEditor from 'components/Dashboard/RichTextEditor';
import { useEffect, useState } from 'react';
import { selectEvents } from 'redux/events/selectors';
import { useAppSelector } from 'redux/hooks';
import { DescriptionImage, DescriptionImageContainer } from './styled';

interface Props {
  eventId: string;
}

export default function Description({ eventId }: Props) {
  const events = useAppSelector(selectEvents);
  const [description, setDescription] = useState('');
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    if (!eventId) return;

    const selectedEvent = events.find((event) => event.id === eventId);

    if (selectedEvent) {
      setDescription(selectedEvent.description || '');
      setImageUrl(selectedEvent.imageUrl || '');
    }
  }, [eventId]);

  if (description) {
    return (
      <>
        <DescriptionImageContainer>
          <DescriptionImage src={imageUrl} alt="Event poster" />
        </DescriptionImageContainer>
        <RichTextEditor description={description} readOnly />
      </>
    );
  }

  return null;
}
